import styled from 'styled-components';

export const LoadingBannerWrapper = styled.div`
  margin-top: 3.2rem;
`;
